import { NgModule } from '@angular/core'
import { NavbarComponent } from '@tv3/layout/navbar/navbar.component'
import { SearchComponent } from '@tv3/layout/navbar/search/search.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { NotificationsComponent } from '@tv3/layout/navbar/notifications/notifications.component'
import { MessagesIconComponent } from './navbar/messages-icon/messages-icon.component'
import { RatesSharedModule } from '@tv3/containers/rates/rates-shared.module'
import { AiResponderModule } from '@tv3/containers/ai-responder/ai-responder.module'
import { SettingsSharedModule } from '@tv3/containers/settings/settings-shared.module'

const pipes = []

const dialogs = []

const declarations = [
  ...pipes,
  ...dialogs,
  NavbarComponent,
  SearchComponent,
  NotificationsComponent,
  MessagesIconComponent,
]

const modules = [SharedModule, RatesSharedModule, AiResponderModule, SettingsSharedModule]

@NgModule({
  imports: [...modules],
  declarations,
  exports: [...declarations, ...modules],
  providers: [...pipes],
  entryComponents: [...dialogs],
})
export class LayoutModule {}
